export const theme = {
  textColor: "#707070",
  textAnswerColor: "#676767"
};
